var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.69 2H8.31C4.67 2 2.5 4.17 2.5 7.81V16.19C2.5 19.83 4.67 22 8.31 22H16.69C20.33 22 22.5 19.83 22.5 16.19V7.81C22.5 4.17 20.33 2 16.69 2ZM10.47 14.9L8.22 17.15C8.07 17.3 7.88 17.37 7.69 17.37C7.5 17.37 7.3 17.3 7.16 17.15L6.41 16.4C6.11 16.11 6.11 15.63 6.41 15.34C6.7 15.05 7.17 15.05 7.47 15.34L7.69 15.56L9.41 13.84C9.7 13.55 10.17 13.55 10.47 13.84C10.76 14.13 10.76 14.61 10.47 14.9ZM10.47 7.9L8.22 10.15C8.07 10.3 7.88 10.37 7.69 10.37C7.5 10.37 7.3 10.3 7.16 10.15L6.41 9.4C6.11 9.11 6.11 8.63 6.41 8.34C6.7 8.05 7.17 8.05 7.47 8.34L7.69 8.56L9.41 6.84C9.7 6.55 10.17 6.55 10.47 6.84C10.76 7.13 10.76 7.61 10.47 7.9ZM18.06 16.62H12.81C12.4 16.62 12.06 16.28 12.06 15.87C12.06 15.46 12.4 15.12 12.81 15.12H18.06C18.48 15.12 18.81 15.46 18.81 15.87C18.81 16.28 18.48 16.62 18.06 16.62ZM18.06 9.62H12.81C12.4 9.62 12.06 9.28 12.06 8.87C12.06 8.46 12.4 8.12 12.81 8.12H18.06C18.48 8.12 18.81 8.46 18.81 8.87C18.81 9.28 18.48 9.62 18.06 9.62Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveReports);
export default __webpack_public_path__ + "static/media/active-reports.efc3e4b47b237757151fce24330a6380.svg";
export { ForwardRef as ReactComponent };